import React, { useState } from "react";
import styles from "./BillsNotes.module.css";
import moment from "moment";

export const BillsNotes = ({ bill_additional_notes, notes }) => {
  const [show, setShow] = useState(true);
  return (
    <div>
      <div className={styles.basicInfoDivPOCard}>
        <div className={styles.BasicInfoTopPOCard}>
          <div className={styles.basicInfoTopImgPOCard}>
            <div>
              <img src="./images/stratum/notes.svg" alt="" />
            </div>
            <h6>Notes</h6>
          </div>

          <img
            src="/images/upArrow.png"
            className={!show && styles.rotateSvg}
            alt=""
            onClick={() => setShow(!show)}
          />
        </div>

        {show && (
          <>
            <div className={styles.basicInfoDetailPOCard}>
              <p>{bill_additional_notes || notes}</p>
            </div>
          </>
        )}
      </div>
    </div>
  );
};
